
































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { TransactionResourceType } from '@/modules/transaction/models/transaction-resource.model'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { PanelLayoutRoute } from '@/modules/common/layout/routes/panel-layout.route'

@Component({
  components: { BaseButton, DateTooltipped }
})
export default class PanelTransactionSuccess extends Vue {
  @Prop() transaction!: TransactionResourceType

  constructor(
    private readonly routes: PanelLayoutRoute
  ) {
    super()
  }


}
